import { Heart, Gavel, MessageCircle, Flame, Users } from "lucide-react";
import heroStream from "@/assets/hero-stream.jpg";

export function StreamMock() {
  return (
    <div className="relative">
      {/* Glow */}
      <div className="absolute -inset-8 -z-10 rounded-[3rem] bg-gradient-primary opacity-30 blur-3xl" />

      <div className="relative aspect-[9/13] w-full max-w-[440px] overflow-hidden rounded-[2rem] shadow-deep">
        <img
          src={heroStream}
          alt="Live stream seller"
          className="h-full w-full object-cover"
          width={1280}
          height={1600}
        />
        {/* darkening gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-background/50 via-transparent to-background/90" />

        {/* Top HUD */}
        <div className="absolute inset-x-0 top-0 flex items-center justify-between p-4">
          <div className="glass flex items-center gap-2 rounded-full px-3 py-1.5">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-pulse-live rounded-full bg-live opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-live" />
            </span>
            <span className="text-xs font-bold tracking-wider">LIVE</span>
          </div>
          <div className="glass flex items-center gap-1.5 rounded-full px-3 py-1.5">
            <Users className="h-3 w-3 text-primary-glow" />
            <span className="text-xs font-semibold">12.4K</span>
          </div>
        </div>

        {/* Bid card */}
        <div className="absolute left-4 top-20 glass-strong rounded-2xl p-3 shadow-elegant">
          <div className="flex items-center gap-2">
            <div className="rounded-lg bg-gradient-primary p-2">
              <Gavel className="h-4 w-4 text-primary-foreground" />
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-wider text-muted-foreground">Maior lance</div>
              <div className="text-base font-extrabold">R$ 1.240</div>
            </div>
          </div>
          <div className="mt-2 h-1 w-32 overflow-hidden rounded-full bg-surface-1">
            <div className="h-full w-2/3 animate-shimmer rounded-full bg-gradient-primary" />
          </div>
        </div>

        {/* Floating reactions */}
        <div className="absolute bottom-32 right-6 flex flex-col gap-3">
          {[0, 0.6, 1.2, 1.8].map((delay, i) => (
            <Heart
              key={i}
              className="h-5 w-5 fill-live text-live animate-float-up"
              style={{ animationDelay: `${delay}s` }}
            />
          ))}
        </div>

        {/* Chat */}
        <div className="absolute inset-x-4 bottom-20 space-y-2">
          {[
            { user: "@nina", msg: "Lance 1,3k 🔥", color: "text-amber" },
            { user: "@max", msg: "Preciso desse drop!", color: "text-primary-glow" },
            { user: "@kira", msg: "Esgotado em todo lugar 😍", color: "text-foreground" },
          ].map((c, i) => (
            <div
              key={i}
              className="glass flex items-center gap-2 rounded-full px-3 py-1.5 text-xs animate-fade-in-up"
              style={{ animationDelay: `${i * 0.15}s` }}
            >
              <span className={`font-bold ${c.color}`}>{c.user}</span>
              <span className="text-foreground/80">{c.msg}</span>
            </div>
          ))}
        </div>

        {/* Bottom action */}
        <div className="absolute inset-x-4 bottom-4 flex items-center gap-2">
          <div className="glass-strong flex flex-1 items-center gap-2 rounded-full px-4 py-2.5">
            <MessageCircle className="h-4 w-4 text-muted-foreground" />
            <span className="text-xs text-muted-foreground">Diga algo...</span>
          </div>
          <button className="rounded-full bg-gradient-primary p-3 shadow-glow">
            <Flame className="h-4 w-4 text-primary-foreground" />
          </button>
        </div>
      </div>
    </div>
  );
}
